import React from 'react';
import { useOffline } from '../contexts/OfflineContext';


const withOffline = (WrappedComponent) => {
    const WithOfflineComponent = (props) => {
        const { isOffline, toggleOfflineState } = useOffline();
        
        return (
            <WrappedComponent
                {...props}
                isOffline={isOffline}
                toggleOfflineState={toggleOfflineState}
            />
        );
    };

    WithOfflineComponent.displayName = `withOffline(${WrappedComponent.displayName || WrappedComponent.name})`;
    
    return WithOfflineComponent;
};

export default withOffline; 